import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";

// const debug = "TaskViaEmailModule"
const debug = false

export class CreateTaskViaEmailModule extends ModuleProto {

    constructor() {
        super(ModuleType.TASK_VIA_EMAIL, {});

        debug && console.log(debug, "constructor() moduleConfig=")

        this.name                       = "Create Task Via Email"
        this.description                = "The Create Task via Email module streamlines your workflow by allowing you to instantly convert incoming emails into actionable tasks. Simply by forwarding an email to a designated address, you trigger the automatic creation of a new task, capturing the email's subject, content, and attachments as task details."
        this.svgIcon                    = "isvg-email-create-task"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel                  = "Integrations"
        this.settingsUrl                = "settings/integrations/task-via-email"
        this.parentSection              = SettingsParentSection.INTEGRATIONS

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }

    enable() {
        this._isEnabled = true
    }

    disable() {
        this._isEnabled = false
    }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
